import React, {useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {connect} from 'react-redux';
import {message} from 'antd';

import HandoutsModal from './HandoutsModal';
import {config} from 'config/config';
import {useLocaleContext} from 'context/LocaleContext';
import {changeScormData} from 'store/actions/scromData';
import {Button} from 'ui';
import useQueryApiClient from 'utils/useApiClient';

const mapStateToProps = (state: any) => ({
    session: state.session,
    activityList: state.campaignActivityList
});

const mapDispatchToProps = (dispatch: any) => ({
    changeScormData: (formData: any) => dispatch(changeScormData(formData))
});

const Buttons: React.FC<any> = ({
    material,
    changeScormData,
}) => {
    const {locale} = useLocaleContext();
    const [isDownloadModalVisible, setIsDownloadModalVisible] = useState(false);

    const intl = useIntl();

    const {appendData: beginActivity, isLoading} = useQueryApiClient({
        request: {
            url: `/api/v1/courses/student/learning-program/${material.id}/begin`,
            method: 'POST',
            baseUrl: config.api.coursesUrl
        },
        onSuccess: (response: any, passOnSuccess: any): void => {
            changeScormData({
                learningActivityId: response.learningActivityId,
                activityAttemptId: response.activityAttemptId,
                programActivityAttemptId: response.programActivityAttemptId,
                materialType: response.materialType,
                type: passOnSuccess.type,
                language: locale,
                learningType: 'PROGRAM'
            })

            if (response?.message) {
                message.error(intl.formatMessage({id: response.message}));
                return;
            }

            setTimeout(function () {
                if (passOnSuccess.isSafari) {
                    passOnSuccess.newWindow.location.href = '/student/show-activity';
                } else {
                    window.open('/student/show-activity');
                }
            }, 100);
        }
    });

    const beginLearning = async (type: 'test' | 'learn') => {
        const userAgent = navigator.userAgent;
        const isSafari = userAgent.includes('Safari') && !userAgent.includes('Chrome');

        if (isSafari) {
            const newWindow = window.open('', '_blank');
            beginActivity({type, language: locale}, null, {type, isSafari, newWindow});
        } else {
            beginActivity({type, language: locale}, null, {type, isSafari});
        }

    }

    const getLearnButtonTitle = () => {
        switch (material?.learningType) {
            case 'ASSESSMENT':
                return 'general.view';

            default:
                break
        }

        switch (material.status) {
            case 'PASSED':
            case 'SUBMITTED':
                return 'general.overview';

            case 'IN_PROGRESS':
                return 'student.continue';

            default:
                return 'student.start_learning';
        }
    }

    const getTestButtonTitle = () => {
        switch (material.status) {
            case 'PASSED':
                return 'learning_tests.test_overview';

            case 'IN_PROGRESS':
                return 'student.continue_test';

            default:
                return 'student.start_test';
        }
    }

    const getTestAccess = () => {
        if (material.testType === 'LEARNING_TEST') {

            if (material.status === 'PASSED') {
                // Reviewing a passed test is allowed only when both flags say so. Without the
                // accessAfterPass part a passed test stayed open for another attempt (CSV-1927).
                return !(material.allowTestReview && material.accessAfterPass)
            }

            if (material.testRepeats < material.learningTestAttempts) {
                return true
            }
        }

        if (material.testType === 'SCORM_TEST') {
            if (material.status === 'PASSED' && !material.accessAfterPass) {
                return true
            }

            if (material.testRepeats + material.lastAttempt <= material.testAttempt) {
                return true
            }
        }

        return material.buttonTest === 'disabled'
    }

    const getLearningAccess = () => {
        return (material.learningStatus === 'PASSED' && !material.accessAfterPass) || material.buttonLearn === 'disabled';
    };

    return (
        <>
            {!!material?.skip && (
                <Button
                    loading={isLoading} type={'primary'}
                    onClick={() => setIsDownloadModalVisible(true)}
                    message='courses.material'
                />
            )}
            {!!material.hasLearning && (
                <Button
                    className={'learning-button'}
                    disabled={getLearningAccess()}
                    loading={isLoading} type={'primary'}
                    onClick={() => beginLearning('learn')}
                    message={getLearnButtonTitle()}
                />
            )}
            {!!material.hasTest && (
                <Button
                    className={'test-button'}
                    disabled={getTestAccess()}
                    loading={isLoading} type={'primary'}
                    onClick={() => beginLearning('test')}
                    message={getTestButtonTitle()}
                />
            )}

            {material?.skip && (
                <HandoutsModal
                    visible={isDownloadModalVisible}
                    onCancel={setIsDownloadModalVisible}
                    files={material.files}
                />
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)((Buttons));
